<template>
  <div class="chat-tabs" :class="[isHidden && 'is-hidden']">
    <ul>
      <li @click="$emit('setTab', 'group')" :class="[curTab === 'group' && 'is-active']">
        <SvgIcon name="chat-group" :alt="$t('chat.tabs-nav.create-group')" />
      </li>
      <li @click="$emit('setTab', 'chats')" :class="[curTab === 'chats' && 'is-active']">
        <SvgIcon name="chat-message" :alt="$t('chat.tabs-nav.chats')" />
      </li>
      <li @click="$emit('setTab', 'attendees')" :class="[curTab === 'attendees' && 'is-active']">
        <SvgIcon name="chat-attendees" :alt="$t('chat.tabs-nav.attendees')" />
      </li>
    </ul>
  </div>
</template>

<script>
import { withUi } from '@/components/ui'

export default {
  components: {},
  mixins: [withUi],
  props: {
    curTab: String,
    isHidden: Boolean,
    setTab: Function,
  },
  methods: {},
}
</script>

<style lang="scss">
.chat-tabs {
  position: relative;
  z-index: 3;
  margin-top: auto;
  background: white;
  height: 60px;
  border-top: 1px solid rgba(180, 187, 198, 0.13);
  transition: height 0.3s ease;
  &.is-hidden {
    height: 1px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
  }
  li {
    position: relative;
    width: 100%;
    min-width: 1px;
    min-height: 0;
    flex: 0 0 33.333%;
    max-width: 33.333%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0;
    padding: 20px 6px;
    cursor: pointer;
    transition: color 0.25s ease-in-out;
    &::after {
      display: inline-block;
      content: ' ';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 4px);
      height: 4px;
      width: 46px;
      background: $primary;
      opacity: 0;
      transition: opacity 0.25s ease, transform 0.3s ease-out;
      will-change: opacity;
      backface-visibility: hidden;
    }
    &:hover {
      color: $primary;
    }
    .svg-icon {
      font-size: 20px;
    }
    &.is-active {
      color: $primary;
      &::after {
        opacity: 1;
        transform: translate(-50%, 0);
      }
    }
  }
  a {
    display: block;
    text-align: center;
  }
}
</style>
